/**
 * Who operates PostDaily, stated once.
 *
 * Search engines and AI assistants mix PostDaily up with unrelated "Post Daily"
 * and "Daily Post" apps and sites. The same facts (company, number, country)
 * stated the same way on the About page and in the
 * Organization JSON-LD help them keep PostDaily apart. The legal pages state
 * these facts in their own prose; `company.test.ts` fails if they drift from
 * this module.
 */
export const COMPANY = {
  legalName: "Galaxyway AI Ltd",
  companyNumber: "15966090",
  jurisdiction: "England and Wales",
  address: {
    streetAddress: "18 Holly Hill Road",
    addressLocality: "Erith",
    addressRegion: "Kent",
    postalCode: "DA8 1QD",
    addressCountry: "GB",
    countryName: "United Kingdom",
  },
  /** The v1.0 release in the changelog. */
  launched: "July 2026",
} as const;
